/*eslint-disable */
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { Marker } from 'react-mark.js';

import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { LoadingButton } from '@mui/lab';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import { TableHead } from '@mui/material';
import TableColumn from './tableCell';
import { fieldsNotToDisplay } from '../../_mock';
import { useNavigate } from 'react-router-dom';


export default function SimpleTable({
  tableData,
  setItemToDeleteId,
  setOpen,
  isSchools,
  setEditData,
  setEditOpen,
  userRole,
  searchedValue,
  manageAvailability,
  isChangingAvailability,
  setAvailabilityPayload,
  availabilityPayload,
  pairedDisplay,
  isEndingTraining,
  setTrainingEndingPayload,
  setCurrentResponse,
  setPairingEndingPayload,
  responses,
  isEndingPairing,
  isViewOnly = false,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const includesPartnerAffiliation = JSON.stringify(tableData).includes('partnerSchool');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - (tableData?.length || 0)) : 0;

  return (
    <TableContainer component={Paper} sx={{ mt: '33px' }}>
      {tableData?.length > 0 ? (
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow sx={{ width: '100%' }}>
              <TableCell />

              <TableCell />

              {tableData?.length &&
                Object.keys(tableData[0] != null ? tableData[0] : [])?.map(
                  (keyName, index) => {
                    const isFirstCell = index === 0;
                    const isLastCell = index === Object.keys(tableData[0]).filter(key =>
                      fieldsNotToDisplay.includes(key) === false &&
                      typeof tableData[0][key] !== 'object'
                    ).length - 1;

                    return fieldsNotToDisplay.includes(keyName) === false &&
                      typeof tableData[0][keyName] !== 'object' && (
                        <TableCell
                          key={index}
                          sx={{
                            textTransform: 'capitalize'
                          }}
                        >
                          {isSchools && keyName === 'name' ? 'Partnership Name' : keyName}
                        </TableCell>
                      );
                  }
                )}

              {/* Add Date/Time header for responses */}
              {responses && (
                <TableCell sx={{ textTransform: 'capitalize' }}>
                  Date & Time
                </TableCell>
              )}

              {includesPartnerAffiliation && (
                <TableCell sx={{
                  textTransform: 'capitalize'
                }}>
                  Partner Affiliation
                </TableCell>
              )}

              {userRole === 'admin' && !pairedDisplay && !isViewOnly && !responses && (
                <TableCell align="center" sx={{ minWidth: '150px' }}>
                  Actions
                </TableCell>
              )}

              {/* <StyledTableCell sx={{ borderBottomRightRadius: '10px' }}>Summary</StyledTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {(rowsPerPage > 0 ? tableData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : rows)?.map( */}

            {tableData?.map(
              (row, index) =>
                row != null &&
                row && (
                  <TableRow
                    key={index}
                    onClick={() => {
                      if (isSchools) {
                        navigate(`/dashboard/school-stats/${row._id}`);
                      }
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'grid' }}>
                        {row?.image ? (
                          <Box
                            component="img"
                            src={
                              isSchools
                                ? `${row?.image}?${row?.updatedAt}`
                                : row?.image
                                  ? row?.image
                                  : "/assets/edifiers/edifier1.svg"
                            }
                            sx={{ width: '40px', height: '40px', borderRadius: '50%' }}
                          />
                        ) : (
                          <AccountCircleIcon sx={{
                            height: '40px',
                            width: '40px',
                            color: theme.palette.success.main
                          }} />
                        )}
                      </Box>
                    </TableCell>

                    {Object.keys(row)?.map(
                      (keyName, index) =>
                        fieldsNotToDisplay.includes(keyName) === false &&
                        typeof row[keyName] !== 'object' && (
                          <TableColumn
                            key={index}
                            index={index}
                            row={row}
                            keyName={keyName}
                            searchedValue={searchedValue}
                            Marker={Marker}
                            manageAvailability={manageAvailability}
                          />
                        )
                    )}

                    {/* Display date/time for responses */}
                    {responses && (row?.timestamp || row?.createdAt) && (
                      <TableCell>
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                          {new Date(row.timestamp || row.createdAt).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                          })}
                        </Typography>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                          {new Date(row.timestamp || row.createdAt).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </Typography>
                      </TableCell>
                    )}

                    {includesPartnerAffiliation && <TableCell> {row?.info?.partnerSchool || 'NA'}</TableCell>}

                    {manageAvailability && (
                      <TableColumn
                        toggleField
                        setAvailabilityPayload={setAvailabilityPayload}
                        row={row}
                        isChangingAvailability={isChangingAvailability}
                        availabilityPayload={availabilityPayload}
                      />
                    )}
                    {userRole === 'admin' && !pairedDisplay && !isViewOnly && !responses && (
                      <TableCell align="center" sx={{ minWidth: '150px' }}>
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isSchools) {
                                  navigate(`/dashboard/school-stats/${row._id}`);
                                }
                              }}
                              sx={{
                                width: 36,
                                height: 36,
                                bgcolor: 'info.lighter',
                                color: 'info.main',
                                '&:hover': {
                                  bgcolor: 'info.light',
                                }
                              }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          
                          <Tooltip title="Edit" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditData(row);
                                setEditOpen(true);
                              }}
                              sx={{
                                width: 36,
                                height: 36,
                                bgcolor: 'primary.lighter',
                                color: 'primary.main',
                                '&:hover': {
                                  bgcolor: 'primary.light',
                                }
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          
                          <Tooltip title="Delete" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setItemToDeleteId(row._id);
                                setOpen(true);
                              }}
                              sx={{
                                width: 36,
                                height: 36,
                                bgcolor: 'error.lighter',
                                color: 'error.main',
                                '&:hover': {
                                  bgcolor: 'error.light',
                                }
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    )}

                    {(userRole === 'admin' || userRole === 'site-leader') && pairedDisplay && !isViewOnly && (
                      <TableCell>
                        <Box sx={{ display: 'flex', columnGap: '10px' }}>
                          <LoadingButton
                            variant="contained"
                            loading={isEndingTraining}
                            disabled={row?.lastSession || isEndingPairing}
                            color="main"
                            sx={{ height: 'fit-content', my: 'auto', width: '150px' }}
                            onClick={() => setTrainingEndingPayload({ id: row?._id })}
                          >
                            {row?.lastSession ? 'Training Ended' : 'End Training'}
                          </LoadingButton>

                          <LoadingButton
                            variant="contained"
                            loading={isEndingPairing}
                            // disabled={row?.lastSession}
                            color="main"
                            sx={{ height: 'fit-content', my: 'auto', width: 'max-content' }}
                            onClick={() => setPairingEndingPayload({ ...row?.usersInPair })}
                          >
                            Unpair{' '}
                          </LoadingButton>
                        </Box>
                      </TableCell>
                    )}

                    {responses && (
                      <TableCell>
                        <LoadingButton
                          variant="contained"
                          color="main"
                          size="small"
                          onClick={() => setCurrentResponse(row)}
                          sx={{ minWidth: '120px' }}
                        >
                          View Response
                        </LoadingButton>
                      </TableCell>
                    )}
                  </TableRow>
                )
            )}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      ) : (
        <Typography variant="h3" sx={{ mb: '5px', color: 'text.titles', textAlign: 'center', py: '20px' }}>
          No Records Found
        </Typography>
      )}
    </TableContainer>
  );
}
